// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"1b51da5d","160":"984c648c","208":"ed04e776","293":"171727b5","453":"b1b22feb","516":"944e464b","519":"3407eecd","917":"ef33b1e6","946":"bfd3d5bb"}[chunkId] + ".chunk.js";
};